var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.white)?_c('img',{attrs:{"src":require("../assets/logo-wave-white.svg"),"alt":_vm.env.image_alt,"width":_vm.width}}):_c('img',{attrs:{"src":require("../assets/logo-wave.svg"),"alt":_vm.env.image_alt,"width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }